var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.146 1.167 6.334 0l7.146 7.146q.479.48.479 1.187 0 .709-.48 1.188l-3.958 3.958q-.48.48-1.187.48-.709 0-1.188-.48L3.188 9.521q-.48-.48-.48-1.188t.48-1.187l3.958-3.98zm3.188 3.187-3.98 3.98h7.959zm7.5 9.813q-.688 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177q0-.438.26-.937.261-.5.573-.938.188-.25.396-.52.208-.271.438-.522.228.25.437.521.209.27.396.521.313.437.573.938t.26.937q0 .687-.49 1.177-.489.49-1.176.49M1.667 20v-3.333h16.667V20z"
  })));
};
export default SvgColor;